import { render, staticRenderFns } from "./MultiplePersonSelect.vue?vue&type=template&id=2c15050b&scoped=true"
import script from "./MultiplePersonSelect.vue?vue&type=script&lang=js"
export * from "./MultiplePersonSelect.vue?vue&type=script&lang=js"
import style0 from "./MultiplePersonSelect.vue?vue&type=style&index=0&id=2c15050b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15050b",
  null
  
)

export default component.exports